<template>
  <div id="articleReports">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" type="text" v-model="postData.title" placeholder="文章标题">
          </p>
          <!-- <p>
            <cander v-model="postData.start" :className="'allInput'" placeholderName="开始时间"  class="d_i" style="vertical-align: middle"></cander>
          </p> -->
          <!-- <p>
            <cander v-model="postData.end" :minDate="postData.start" :className="'allInput'" placeholderName="结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p> -->
          <button @click="getList(1)" class="redButtonTwo">搜索</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <nav class="m_b_10"><button class="redButtonTwo" @click="exportList">导出</button></nav>
        <div style="overflow:auto; width: 100%;">
          <table cellspacing="0" class="allTable" :style="myList.length > 0 ? 'width: 110%;' : 'width: 100%;'">
            <thead>
              <tr>
                <!-- <th class="t_c">推送日期</th> -->
                <th class="t_c">文章标题</th>
                <th class="t_c">阅读次数</th>
                <th class="t_c">阅读人数</th>
                <th class="t_c">收藏人数</th>
                <th class="t_c">分享次数</th>
                <th class="t_c">分享人数</th>
                <th class="t_c">阅读原文次数</th>
                <th class="t_c">阅读原文人数</th>
                <th class="t_c">收藏原文人数</th>
                <th class="t_c">分享原文次数</th>
                <th class="t_c">分享原文人数</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="myList.length > 0">
                <tr :key="index" v-for="(item, index) in myList">
                  <!-- <td width="10%" class="t_c NoWrap">{{item.pushTime}}</td> -->
                  <td width="10%" class="NoWrap">{{item.title}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.int_page_read_count}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.int_page_read_user}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.add_to_fav_user}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.share_count}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.share_user}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.ori_page_read_count}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.ori_page_read_user}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.ori_add_to_fav_user}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.ori_page_share_count}}</td>
                  <td width="10%" class="t_c NoWrap">{{item.ori_page_share_user}}</td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td style="border: none; text-align: center;" :colspan="11">暂无数据</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'articleReports',
  data () {
    return {
      postData: {
        title: '',
        start: '',
        end: ''
      },
      myList: [],
      totalPage: 0,
      totalCount: 0,
      page: 1,
      pageSize: 10
    }
  },
  created () {
    // 获取列表
    this.getList(1)
  },
  mounted () {

  },
  methods: {
    getList (page) {
      this.page = page
      this.$axiox.get(`/api/push/queryReport?title=${this.postData.title}&startPush=${this.postData.start}&endPush=${this.postData.end}&PageIndex=${page}&PageSize=${this.pageSize}`).then(res => {
        console.log(res, 'getList')
        if (res.data && res.data.length > 0) {
          this.myList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.myList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },
    exportList () {
      let beginTime = this.postData.start
      let endTime = this.postData.end ? this.postData.end + ' 23:59:59' : ''
      axios.get(`/api/push/ReportExport?title=${this.postData.title}&startPush=${beginTime}&endPush=${encodeURIComponent(endTime)}`, {responseType: "arraybuffer"})
      .then(res => {
        console.log(res, 'exportList')
        const data = res.data
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '文章报告.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/articleReports.vue